import { createAsyncThunk } from "@reduxjs/toolkit";
import { URL_PROVINCES } from "../../config/connString";
import useAxios from "../../utils/useAxios";

const getProvinceLookUp = createAsyncThunk(
  "provinces/get-provinces-look-up",
  async () => {
    try {
      const api = useAxios();
      const response = await api.get(URL_PROVINCES + "/provinces-lookup");
      return response.data;
    } catch (error) {
      return Promise.reject(error.response);
    }
  }
);

export { getProvinceLookUp };
